import { render, staticRenderFns } from "./DepartmentTree.pug?vue&type=template&id=196de0c6&scoped=true&lang=html&"
import script from "./DepartmentTree.ts?vue&type=script&lang=ts&"
export * from "./DepartmentTree.ts?vue&type=script&lang=ts&"
import style0 from "./DepartmentTree.styl?vue&type=style&index=0&id=196de0c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196de0c6",
  null
  
)

export default component.exports